import {React, useState} from 'react'
import { useTranslate,Form,useRecordContext, useNotify } from 'react-admin'
import { Grid, Button, TextField} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import SaveIcon from '@mui/icons-material/Save'
import LoadingButton from '@mui/lab/LoadingButton'
import { itemServices } from 'src/services/reservation/item/item.service'

export const HotelCodeEditModal = ({setOpenCodeModal, refresh}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const hotel = useRecordContext()
    const [isLoading, setIsLoading] = useState(false)
    const provider =  hotel?.gmx_order_id
    const [form, setForm] = useState({
        gmx_order_id:provider,
        provider_code: hotel.provider_code,
        gmx_segment_id:hotel.gmx_segment_id
    })

    const onChangeForm = (field, value) =>{
        setForm({...form, [field]:value.target.value})
    }

    const postSave = async ()=>{
        setIsLoading(true)
        await itemServices.editHotelCodes(hotel.id_detail,form).finally(()=>{
            setIsLoading(false)
        }).then(()=>{
            setOpenCodeModal(false)
            refresh()
        }).catch(err=>{
            console.log("err", err)
            notify('ra.notification.edit_codes_error',{type:'error'})
        })
    }
  return (
    <div>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave}>
            <Grid id='post_create_form' container spacing={3}>
                <EditInputsWrap md={12} label={translate(`${translate('ra.field.provider_code')} 1`)}  >
                    <TextField onChange={(value)=>onChangeForm('gmx_order_id', value)} value={form.gmx_order_id} size='small' fullWidth />
                </EditInputsWrap>
                <EditInputsWrap md={12} label={translate(`${translate('ra.field.provider_code')} 2`)} >
                    <TextField onChange={(value)=>onChangeForm('provider_code', value)} value={form.provider_code} size='small' fullWidth />
                </EditInputsWrap>
                <EditInputsWrap md={12} label={translate('ra.field.gmx_segment_id')} >
                    <TextField onChange={(value)=>onChangeForm('gmx_segment_id', value)} value={form.gmx_segment_id} size='small' fullWidth />
                </EditInputsWrap>
            </Grid>
        </Form>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
        <LoadingButton
            loading={isLoading}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
            >
            {translate('ra.action.save')}
            </LoadingButton>
            <Button onClick={()=>setOpenCodeModal(false)} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
            </Button>
        </div>
    </div>
  )
}
